/**
 * @fileOverview Universal link tracker for all activity views.
 * @author jzetlen
 *
 * A function that will call `Backbone.trigger('trackLink'...`
 * appropriately with the declared prefix on all events.
 *
 * TODO: integrate into all existing views instead of verbose Backbone call.
 *
 */

import { createLinkTracker } from 'lib/fpti-utils';

const prefix = 'main:walletweb:activity';

const trackLink = createLinkTracker(prefix);

export default trackLink;



// WEBPACK FOOTER //
// ./view/activity/trackLink.es6